
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import MidBox from '../components/Boxes/MidBox'
import Network from '../utils/Network'
import { motion } from 'framer-motion'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import Button from '../components/Button'
import { isMobile } from 'react-device-detect'
import Dialog from '../components/Dialog'
import useToast from '../hooks/useToast'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import ThousandsSeparator from '../utils/thousands-separator'
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from 'react-redux'
import truncateString from '../utils/truncate-string'
import Countdown from 'react-countdown'
import { Helmet } from 'react-helmet'
import { useAppTranslation } from '../i18n/useAppTranslation'

type Props = {}
const ReferralLeaderBoard = (props: Props) => {
    const { t } = useAppTranslation(["referrals", "village", "common"])

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [paginations, setPaginations] = useState({ page: 1, count: 100, total: 1 })
    const [markLoading, setMarkLoading] = useState(false)
    const [offerDialog, setOfferDialog] = useState(false)
    const [stats, setStats] = useState({
        all: 0,
        poolCharge: 0,
        poolPrize: 0,
        dragons: 0,
        mages: 0
    })

    const userInfo = useSelector((state: any) => state.userInfo)
    const [detailDialog, setDetailDialog] = useState({
        open: false,
        data: {}
    })

    const openToast = useToast()
    const axios = new Network()
    const navigate = useNavigate();

    const getData = async (page = 1) => {
        const response = await axios.CallApi({
            url: '/Bonus/ReferralContest20230315',
            method: 'get'
        })
        if (response.ok) {
            setData(response?.data || [])
            let all = 0;
            let poolCharge = 0
            let poolPrize = 0
            let dragons = 0
            let mages = 0
            for (let key in response?.data) {

                all += (response?.data[key]?.inviteCount)
                poolCharge += (response?.data[key]?.rewardPoolShare)
                // poolPrize += (response?.data[key]?.rewardPoolPrize)
                poolPrize += (response?.data[key]?.inviteCount) * 100
                if (response?.data[key]?.troopName === "Mage") mages += (Math.pow(2, response?.data[key]?.level - 1)) * 2
                if (response?.data[key]?.troopName === "Dragon") dragons += Math.pow(2, response?.data[key]?.level - 1)
            }
            setStats({
                all, poolCharge, poolPrize, dragons, mages
            })
            setPaginations({ total: Math.ceil(response.data.totalCount / 100), page, count: 100 })
        }
        setLoading(false)
    }

    useEffect(() => {
        setLoading(true)
        getData()
    }, [])
    return (
        <SkeletonTheme baseColor='#3e382b' highlightColor='#474132'>
                 <Helmet>
                <title key={'title'}>
                    {t("referrals:leaderboard.metaTitle")}
                </title>
            </Helmet>
            <motion.div
                exit={{ opacity: 0, y: 200 }}
                transition={{ duration: 0.4 }}
                initial={isMobile ? undefined : { opacity: 0, y: 200 }} animate={{ opacity: 1, y: 0 }}
                className='row'
            >

                <MidBox modal title={t("referrals:leaderboard.title")}>
                    <img style={{ position: 'absolute', top: 10, left: 10 }} className="" src="/assets/images/icons/referral.png" width={80} height="auto" />
                    <img style={{ position: 'absolute', top: 10, right: 10 }} className="" src="/assets/images/icons/referral.png" width={80} height="auto" />
                    <div className='text-center d-flex  justify-content-center flex-wrap align-items-center'>
                        <h3>
                            {t("referrals:leaderboard.event.title")}
                        </h3>&nbsp;
                        <Button onClick={() => setOfferDialog(true)} style={{ paddingInline: 5, minWidth: 80 }} variant='primary'>
                            <img src="/assets/images/icons/info.png" width={22} />    {t("common:actions.info")}
                        </Button>
                    </div>
                    <div className='d-flex mt-3 flex-wrap align-items-center justify-content-center'>
                        <div className='text-center  text-danger'>
                            {t("referrals:leaderboard.event.remainingTime")}
                        </div>
                        <div className='ms-2'>
                            <Countdown
                                date={new Date('Thu, 11 Jul 2023 00:00:00 GMT')}
                                renderer={({ formatted, days }) => (
                                    <div className='fs-big d-flex'>  
                                        {days ?
                                            <div className='time-badge'>
                                                {formatted.days}
                                                <span className='dark-yellow'>
                                                    {t("referrals:leaderboard.time.days")}
                                                </span>
                                            </div> : ''}
                                        <div className='ms-2 time-badge'>
                                            {formatted.hours}
                                            <span className='dark-yellow'>
                                                {t("referrals:leaderboard.time.hours")}
                                            </span>
                                        </div>
                                        <div className='ms-2 time-badge'>
                                            {formatted.minutes}
                                            <span className='dark-yellow'>
                                                {t("referrals:leaderboard.time.minutes")}
                                            </span>
                                        </div>
                                        <div className='ms-2 time-badge'>
                                            {formatted.seconds}
                                            <span className='dark-yellow'>
                                                {t("referrals:leaderboard.time.seconds")}
                                            </span>
                                        </div>
                                    </div>
                                )}
                            />
                        </div>
                    </div>

                    <div className='row mx-0 mx-md-3 mt-4'>
                        <div className='col-12 my-2 my-md-0 col-md-3'>
                            <div className='stats-box flex-row'>
                                <div style={{ width: 80 }}>
                                    <img width={80} src="https://core.chainoflegends.com/assets/troops/image/mage.webp" />
                                </div>
                                <div>
                                    <h6>
                                        {t("referrals:leaderboard.stats.grantedMages")}
                                    </h6>
                                    <h4 className=' mt-3'>
                                        {stats.mages}
                                    </h4>
                                </div>

                            </div>
                        </div>
                        <div className='col-12 col-md-6'>
                            <div className='stats-box 
                            flex-column flex-md-row
                            '>
                                <div style={{ width: 80, height: 110 }} className="d-flex align-items-center">
                                    <img width={50} src="/assets/images/icons/cleg.png" />
                                </div>
                                <div>
                                    <h5>
                                        {t("referrals:leaderboard.stats.totalSuccessfulReferrals")}:&nbsp;&nbsp;{stats.all}
                                    </h5>

                                    <h5>
                                        {t("referrals:leaderboard.stats.rewardPool")}:&nbsp;&nbsp;{stats.poolPrize}
                                    </h5>

                                    <div className='fs-tiny'>
                                        {t("referrals:leaderboard.stats.rewardPoolNote")}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='col-12 my-2 my-md-0 col-md-3'>
                            <div className='stats-box flex-row'>
                                <div>
                                    <img width={100} height={110} src="/assets/images/dragon-flying.webp" />
                                </div>
                                <div>
                                    <h6>
                                        {t("referrals:leaderboard.stats.grantedDragons")}
                                    </h6>
                                    <h4 className=' mt-3'>
                                        {ThousandsSeparator(stats.dragons)}
                                    </h4>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div style={{ overflow: 'auto' }} className="pe-1 pt-3 pb-5 ps-1 mt-2 pe-sm-3 ps-sm-3 pb-4 table-box">
                        <table className="table table-borderless m-0 text-white" > <thead>
                            <tr>
                                <th scope="col">{t("referrals:leaderboard.table.rank")}</th>
                                <th style={{ textAlign: 'center' }} align='center'>
                                    {t("referrals:leaderboard.table.successfulReferrals")}
                                    <OverlayTrigger
                                        trigger="click"
                                        // popperConfig={{}}
                                        placement={"top"}

                                        overlay={
                                            <Tooltip >
                                                {t("referrals:leaderboard.tooltips.successfulReferrals")}
                                            </Tooltip>
                                        }
                                    >
                                        <img className='ms-1 pointer' src="/assets/images/icons/info.png" width={20} />
                                    </OverlayTrigger>
                                </th>
                                <th style={{ textAlign: 'center' }} scope="col">{t("referrals:leaderboard.table.bonusTroop")}

                                </th>
                                <th style={{ textAlign: 'center' }} scope="col">{t("referrals:leaderboard.table.remainingInvites")}
                                    <OverlayTrigger
                                        // popperConfig={{}}
                                        placement={"top"}
                                        trigger="click"
                                        overlay={
                                            <Tooltip >
                                                {t("referrals:leaderboard.tooltips.remainingInvites")}
                                            </Tooltip>
                                        }
                                    >
                                        <img className='ms-1 pointer' src="/assets/images/icons/info.png" width={20} />
                                    </OverlayTrigger>
                                </th>
                                <th style={{ textAlign: 'center' }} scope="col">{t("referrals:leaderboard.table.rewardPoolShare")}</th>
                                <th style={{ textAlign: 'center' }} scope="col">{t("referrals:leaderboard.table.rewardPoolPrize")}
                                    <OverlayTrigger
                                        // popperConfig={{}}
                                        placement={"top"}
                                        trigger="click"
                                        overlay={
                                            <Tooltip >
                                                {t("referrals:leaderboard.tooltips.rewardPoolPrize")}
                                            </Tooltip>
                                        }
                                    >
                                        <img className='ms-1 pointer' src="/assets/images/icons/info.png" width={20} />
                                    </OverlayTrigger>
                                </th>
                                <th scope="col">{t("referrals:leaderboard.table.walletAddress")}</th>
                            </tr>
                        </thead>
                            <tbody>
                                {loading && [1, 2, 3].map((item) =>
                                    <tr key={"loading" + item} className=''
                                    >
                                        <td width={"50%"}>
                                            <Skeleton width={'100%'} />
                                        </td>
                                        <td> <Skeleton width={'60px'} /> </td>
                                        <td> <Skeleton width={'60px'} /></td>
                                        <td >
                                            <Skeleton width={'100px'}
                                                height={25}
                                            />
                                        </td>
                                    </tr>
                                )}
                                {data.length === 0 && !loading && <tr>
                                    <td colSpan={4} style={{ textAlign: 'center', paddingTop: 40, fontSize: 20, paddingBottom: 40, }} className="dark-yellow">
                                        {t("referrals:leaderboard.table.empty")}
                                    </td>
                                </tr>}
                                {!loading && data?.map((item, key) => (
                                    <>
                                        <tr className=''
                                            onClick={() => { }}
                                            style={{ opacity: !item?.isRead ? 1 : 0.7 }}
                                            key={"row" + key}>

                                            <td >
                                                <span className='fs-big' >
                                                    {key < 3 ? <img width={25} src={`/assets/images/icons/${key === 0 ? 'first' : key === 1 ? 'second' : 'third'}-place.png`} />
                                                        : <>#{key + 1}</>
                                                    }
                                                </span>
                                            </td>
                                            <td align='center' >
                                                <span className='fs-big bold' >
                                                    {item.inviteCount}
                                                </span>
                                            </td>
                                            <td align='center'  >
                                                <span className='fs-big'>
                                                    <span className={item?.troopName === 'Mage' ? 'text-pink' : 'text-danger'}>
                                                        {item?.troopName}
                                                    </span>  <small>
                                                        {t("referrals:leaderboard.labels.levelShort")} {item?.level}
                                                    </small>
                                                </span>
                                            </td>
                                            <td align='center'  >
                                                <span className='fs-big'>
                                                    {item?.remainingInvites}
                                                </span>
                                            </td>
                                            <td align='center'  >
                                                <span
                                                    style={{
                                                        color: key === 0 ? '#f6e89f' : key === 1 ? '#87dde0' : key === 2 ? '#e19b7b' : ''
                                                    }}
                                                    className='fs-big'>
                                                    {item?.rewardPoolShare}%
                                                </span>
                                            </td>
                                            <td align='center'  >
                                                <span
                                                    style={{
                                                        color: key === 0 ? '#f6e89f' : key === 1 ? '#87dde0' : key === 2 ? '#e19b7b' : ''
                                                    }}
                                                    className='fs-big'>
                                                    {item?.rewardPoolPrize}&nbsp;<small>
                                                        {t("village:resources.cleg")}
                                                    </small>
                                                </span>
                                            </td>
                                            <td >
                                                <div className='fs-big d-flex align-items-center'>
                                                    {item?.walletAddress?.toLowerCase() === userInfo?.walletAddress?.toLowerCase() && <img width={20} className="me-2" height={20} src="/assets/images/icons/star.svg" />}
                                                    {truncateString(item?.walletAddress)}
                                                </div>
                                            </td>
                                        </tr>

                                    </>
                                ))}

                            </tbody>
                        </table>
                        <br />
                    </div>
                </MidBox>
            </motion.div>


            <Dialog onClose={() => {
                setOfferDialog(false)
                localStorage.setItem('ref-contest', 'true')
            }}
                title={t("referrals:leaderboard.offerDialog.title")}
                open={offerDialog}>

                <img className='rounded' width={'100%'} src="/assets/images/ref-rampage.jpg" />
                <h4 className='mt-3 text-center'>
                    {t("referrals:leaderboard.offerDialog.heading")}
                </h4>
                <h5 className='mt-3 bold text-center dark-yellow'>
                    {t("referrals:leaderboard.offerDialog.subheading")}
                </h5>
                <p className='fs-med' >
                    {t("referrals:leaderboard.offerDialog.lead")}
                </p>
                <p className='fs-med' style={{ textAlign: 'justify' }}>
                    {t("referrals:leaderboard.offerDialog.body")}
                </p>
                <h5 className='mt-3  dark-yellow'>
                    {t("referrals:leaderboard.offerDialog.startDate")}<br />
                    {t("referrals:leaderboard.offerDialog.endDate")}
                </h5>
                <hr />
                <div>
                    {t("referrals:leaderboard.offerDialog.note")}
                </div>
                <Link to="/referral-leaderboard">
                    <Button
                        onClick={() => {
                            setOfferDialog(false)
                            localStorage.setItem('ref-contest', 'true')
                        }}
                        style={{ marginBottom: -60 }} variant='wide-primary' className='mx-auto' >
                        {t("referrals:leaderboard.offerDialog.button")}
                    </Button>
                </Link>
            </Dialog>

            <Dialog title={t("referrals:leaderboard.detailTitle")} open={detailDialog.open} onClose={() => setDetailDialog((prev) => ({ ...prev, open: false }))}>
                <div className='row flex-column'>
                    <div className='d-flex'>


                    </div>
                </div>
                {detailDialog?.data?.message}
            </Dialog>
        </SkeletonTheme >
    )
}

export default ReferralLeaderBoard
